import { render, staticRenderFns } from "./seedatails.vue?vue&type=template&id=4ee345c6&scoped=true&"
import script from "./seedatails.vue?vue&type=script&lang=js&"
export * from "./seedatails.vue?vue&type=script&lang=js&"
import style0 from "./seedatails.vue?vue&type=style&index=0&id=4ee345c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee345c6",
  null
  
)

export default component.exports